import { useEffect, useState } from "react";
import "./CatchAllResolverPromo.css";

// "Catch-All Resolver - New" card for the Email Verifier page. Learn more
// opens the how-to video (frontend/public) in a popup.

const VIDEO_SRC = "/How-to-Use-Catch-All-Resolver-v3.mp4";

const CatchAllResolverPromo = () => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!open) return;
        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Escape") setOpen(false);
        };
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [open]);

    return (
        <>
            <div className="car-promo">
                <div className="car-promo-text">
                    <p className="car-promo-title">
                        Catch-All Resolver <span className="car-promo-badge">New</span>
                    </p>
                    <p className="car-promo-desc">
                        Run an additional check on Catch-All emails to help determine whether they are Valid or Invalid.
                    </p>
                </div>
                <button type="button" className="car-promo-btn" onClick={() => setOpen(true)}>
                    Learn more
                </button>
            </div>

            {open && (
                <div className="car-video-overlay" onClick={() => setOpen(false)}>
                    <div
                        className="car-video-modal"
                        role="dialog"
                        aria-modal="true"
                        aria-label="How to use the Catch-All Resolver"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button type="button" className="car-video-close" aria-label="Close" onClick={() => setOpen(false)}>
                            <img src="/images/v-close.svg" alt="" width={30} height={30} />
                        </button>
                        {/* No Download / Playback speed / Picture in picture in the
                            player's menu, and no right-click "Save video as". */}
                        <video
                            className="car-video"
                            src={VIDEO_SRC}
                            controls
                            controlsList="nodownload noplaybackrate noremoteplayback"
                            disablePictureInPicture
                            onContextMenu={(e) => e.preventDefault()}
                            autoPlay
                            playsInline
                            preload="metadata"
                        >
                            Your browser can't play this video.
                        </video>
                    </div>
                </div>
            )}
        </>
    );
};

export default CatchAllResolverPromo;
